import React from "react";

import pkg from "../../lib/pkg";
import { AnalyticsError } from "../../lib/util";
import { IntegrationCategory } from "../../providers/AnalyticsContext";
import useTrackEvent from "../useTrackEvent";
import { mapActivityListingsToProducts } from "./util";

import type { ActivityListing, Products } from "./types";

const EVENT_NAME = "Order Refunded";

interface RefundedProperties {
  order_id: string;
  total: number;
  currency: string;
  products: Products;
}

export default function useOrderRefunded() {
  const trackAdEvent = useTrackEvent(IntegrationCategory.Advertising);

  function track(
    orderSlugID: string,
    refundAmountCents: number,
    currency: string,
    activityListing: ActivityListing
  ) {
    try {
      const products = mapActivityListingsToProducts([activityListing]);

      const properties: RefundedProperties = {
        order_id: orderSlugID,
        total: refundAmountCents / 100,
        currency: currency,
        products: products,
      };

      trackAdEvent(EVENT_NAME, properties);
    } catch (error) {
      pkg.onError(new AnalyticsError(EVENT_NAME, error));
    }
  }

  return React.useCallback(track, [trackAdEvent]);
}
